import { Directive, ElementRef, Renderer2, AfterViewInit, HostListener } from '@angular/core';

@Directive({
  selector: '[appTargetBlank]',
})
export class TargetBlankDirective implements AfterViewInit {
  constructor(private elementRef: ElementRef, private renderer: Renderer2) {}


  @HostListener('click') onClick() {
    this.ngAfterViewInit();
  }

  ngAfterViewInit() {
    const links = this.elementRef.nativeElement.querySelectorAll('a');
    links.forEach((link: any) => {
      this.renderer.setAttribute(link, 'target', '_blank');
    });
  }
}
